import { useDecision } from '@optimizely/react-sdk';
import { useSearchContext } from '@src/components/Providers/SearchProvider/SearchProvider';
import { LIMITED_CATALOG, WFM_INTERNATIONAL } from '@src/constants/featureFlags';

interface WfmInternationalVariables {
	wfm_international_plan_ids: {
		intl_plan_ids: string[];
	};
}

export const useLimitedCatalog = () => {
	const { planUuid } = useSearchContext();
	const [wfmInternationalDecision] = useDecision(WFM_INTERNATIONAL);

	const variables = wfmInternationalDecision?.variables as unknown as
		| WfmInternationalVariables
		| undefined;
	const wfmVariablePlanConfig = variables?.wfm_international_plan_ids?.intl_plan_ids;

	const isInWfmInternationalPlan = wfmVariablePlanConfig?.includes(planUuid);

	// Separate decision for other users who match the limited catalog flag rules
	const [limitedCatalog] = useDecision(LIMITED_CATALOG);

	return {
		limitedCatalogEnabled:
			(!!wfmInternationalDecision?.enabled && !!isInWfmInternationalPlan) ||
			!!limitedCatalog?.enabled,
	};
};
